import { Http } from '@/lib/http';

export class ComparisonOptionsService extends Http {
  constructor() {
    super();
    this.endpoint = 'delinquency-pro/settings/automated-spooling-report';
  }

  create(payload) {
    return this.httpClient().post(`${this.endpoint}`, payload);
  }

  find() {
    return this.httpClient().get(`${this.endpoint}`);
  }

  update(id, updates) {
    return this.httpClient().patch(`${this.endpoint}/${id}`, updates);
  }
}
